define([
	"dojo/_base/declare",
	"csi/heading/Boolean",
	"Apparel/ColorwayMixin"
], function(declare,BooleanRen,ColorwayMixin) {

	return declare([BooleanRen, ColorwayMixin], {
		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: disable filtering
			return null;
		},

		_getValue: function(/*csi.def.Context*/ctx, /*csi.def.Heading*/h) {
			// summary: determine if colorway color is in theme - empty colors are considered not in theme
			return this._isColorInTheme(ctx, false);
		}
	});
});